import { useParams } from 'react-router-dom';

import { CRUDTable } from 'components';

import { useDeleteRequest, useGetRequest, usePostRequest, useUserRole } from 'hooks';

import { BaseIssuanceRetailerProductExclusion, ProductDashboardDto } from 'codegen';

import {
  columns,
  handleDeleteProductExclusion,
  handlePostProductExclusion,
  initialTableActions,
} from './lib';

import { retailerStore, setProductExclusionsAction } from '../../store';

export const ProductExclusionTable = () => {
  const baseIssuanceProductExclusions = retailerStore((state) => state.baseIssuanceProductExclusions);

  const { retailerId } = useParams();

  const { data } = useGetRequest<{ products: ProductDashboardDto[] }>({
    url: '/products',
    queryParams: {
      size: 500,
    },
  });

  const [addExclusion, { loading }] = usePostRequest<BaseIssuanceRetailerProductExclusion, BaseIssuanceRetailerProductExclusion>({
    options: {
      onSuccess: (d) => {
        setProductExclusionsAction([...baseIssuanceProductExclusions, d.data]);
      },
    },
  });

  const [deleteProductExclusion, { loading: deleteLoading }] = useDeleteRequest({
    options: {
      onSuccess: (_, args) => {
        const { url } = args[0];
        const id = url.split('/').pop();

        setProductExclusionsAction(baseIssuanceProductExclusions.filter((exclusion) => exclusion.id !== id));
      },
    },
  });

  const { isAdmin } = useUserRole();

  return (
    <CRUDTable
      title='Product Exclusion'
      loading={deleteLoading || loading}
      columns={columns(data?.products)}
      addNewBtn={{ visible: isAdmin }}
      dataSource={baseIssuanceProductExclusions}
      initialTableActions={isAdmin ? initialTableActions : undefined}
      onPostTableData={handlePostProductExclusion(addExclusion, retailerId)}
      onDeleteTableData={handleDeleteProductExclusion(deleteProductExclusion, retailerId)}
    />
  );
};
